import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import 'moment/locale/pt-br';
import 'moment/locale/es';
import 'date-fns';
import templateTypes from '../../constants/templateTypes';

/** Components */
import { Button, InputField, Modal, Text } from '@getpingback/realeza';
import Select from 'react-select';
import {
  Switch,
  FormControlLabel,
  CircularProgress,
  AppBar,
  Tabs,
  Tab,
  Grid,
  Divider,
  TextField,
  InputBase,
  Select as MuiSelect,
  MenuItem,
  InputLabel,
  Input,
} from '@material-ui/core';
import { Save } from '@material-ui/icons';
import CardMetrics from './../../components/CardMetrics';
import EditableInput from '../../components/EditableInput';
import EditableDateInput from '../../components/EditableDateInput';
import EditableSelect from './../../components/EditableSelect';
import UneditableInput from '../../components/UneditableInput';
import ImportData from './components/ImportData';
import ExportData from './components/ExportData';
import TabPanel from '../../components/TabPanel';
import Payments from '../Payments';
import BankAccounts from '../BankAccounts';
import Recipients from '../../components/Recipients/Recipients';
import ChannelInfos from './components/ChannelInfos';
import PlanComsumptionTable from './components/PlanComsumptionTable';
import Loading from '../../components/Loading';

/** Services */
import { clearCacheCloudFront } from '../../services/user';
import {
  getChannels,
  updateChannel,
  getRecipientData,
  sendCsv,
  setRecipientToManual,
  getAddressInformation,
  addAddressToChannel,
  getEmailTemplateStyles,
  addNewEmailTemplateStyle,
  getChannelMembersByUid
} from '../../services/channel';
import { sendImportFile } from '../../services/utils';
import { sendTemplate } from '../../services/issue';
import { giveSaasForFree, getPlanUsages, getPlans } from '../../services/saas';
import { createCustomTemplate } from '../../services/customTemplate';
import { getChannelPlans, updateChannelPlans } from '../../services/plans';

/** Actions */
import { showAlert } from '../../store/ducks/alert';
import { useCallback } from 'react';

/** helper */
import { formatCurrency, formatCurrencyToApiString } from '../../helpers/formatCurrency';
import DataTable from '../../components/Table/DataTable';
import {
  getChannelCustomSender
} from '../../services/customSenders';
import { PlusIcon, TrashCanIcon } from '@stash-ui/regular-icons';
import { addRewardToPlan, getChannelPlansBySlug, removePlanReward } from '../../services/channelPlan';

const ChannelsInformation = props => {
  const dispatch = useDispatch();
  const [address, setAddress] = useState({});
  const [channel, setChannel] = useState({});
  const [planComsumption, setPlanComsumption] = useState({});
  const [uid, setUid] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingFile, setIsLoadingFile] = useState(false);
  const [isLoadingTemplate, setIsLoadingTemplate] = useState(false);
  const [resetFile, setResetFile] = useState(false);
  const [importType, setImportType] = useState('csv');
  const [recipient, setRecipient] = useState(null);
  const [panelIndex, setPanel] = useState(11);
  const [selectedFile, setSelectedFile] = useState();
  const [isFilePicked, setIsFilePicked] = useState(false);

  const [customHtmlVisibilityOptions, setCustomHtmlVisibilityOptions] = useState({
    forMembers: false,
    forNonMembers: false,
    onlyForSubscribersOrMembers: false,
  });
  const [fileText, setFileText] = useState({ title: '', description: '', author: '' });
  const [customTemplateFile, setCustomTemplateFile] = useState({ typeTransactionalEmail: '', subject: '' });
  const [scheduledTo, setScheduledTo] = useState({ scheduledDate: moment().toDate() });

  const [withdrawChangeRequesting, setWithdrawChangeRequesting] = useState(false);

  const [currentSaasPlanSelected, setCurrentSaasPlanSelected] = useState(null);
  const [isLoadingGiveSaas, setIsLoadingGiveSaas] = useState(false);
  const currency = 'BRL';

  const [plansValue, setPlansValue] = useState({});
  const [plansInterval, setPlansInterval] = useState({});
  const [plansType, setPlansType] = useState({});

  const [emailTemplateStyles, setEmailTemplateStyles] = useState([]);
  const dataTableEmailTemplateStylesHeaders = ['id', 'name', 'isEnabled', 'createdAt', 'updatedAt'];

  const [isLoadingCustomSenders, setIsLoadingCustomSenders] = useState(false);
  const [customSenderAlias, setCustomSenderAlias] = useState('');
  const [isLoadingAddCustomSender, setIsLoadingAddCustomSender] = useState(false);
  const [customSenders, setCustomSenders] = useState([]);
  const [channelCustomSenders, setChannelCustomSenders] = useState([]);
  const [customSenderModalConfig, setCustomSenderModalConfig] = useState({
    isOpen: false,
    isEditMode: false,
    customSenderId: null,
  });

  const [channelPlans, setChannelPlans] = useState([]);
  const [rewardNameValue, setRewardNameValue] = useState('');
  const [rewardModalConfig, setRewardModalConfig] = useState({
    isOpen: false,
    planId: null,
  });

  const [channelMembers, setChannelMembers] = useState([]);

  useEffect(() => {
    displayChannel();
  }, []);

  useEffect(() => {
    if (panelIndex === 4) {
      getTemplateStyles();
    }
    // if (panelIndex === 7) {
    //   getPlansTypes();
    // }
    if (panelIndex === 5) {
      listCustomSenders();
    }
    if (panelIndex === 6) {
      getChannelMembers();
    }
  }, [panelIndex]);

  const selectTypes = [
    { value: 'month', label: 'Every month' },
    { value: 'quarterly', label: 'Every 3 months' },
    { value: 'semester', label: 'Every 6 months' },
    { value: 'yearly', label: 'Every year' },
  ];

  const handleUpdate = async e => {
    e.preventDefault();

    try {
      await updateChannel(channel.id, channel);
      dispatch(showAlert('success', 'Channel has been updated! 🔥'));
    } catch (error) {
      dispatch(showAlert('error', 'Error! We could not update the channel. 😔'));
      console.log(error);
    }
  };

  const handleChangeVisibility = e => {
    const { value } = e.target;

    if (value === 'all') setCustomHtmlVisibilityOptions({ forMembers: true, forNonMembers: true, onlyForSubscribersOrMembers: false });
    else if (value === 'subscribed-only')
      setCustomHtmlVisibilityOptions({ forMembers: true, forNonMembers: true, onlyForSubscribersOrMembers: true });
    else if (value === 'free-members-only')
      setCustomHtmlVisibilityOptions({ forMembers: false, forNonMembers: true, onlyForSubscribersOrMembers: false });
    else if (value === 'paid-members-only')
      setCustomHtmlVisibilityOptions({ forMembers: true, forNonMembers: false, onlyForSubscribersOrMembers: false });
  };

  const displayChannel = async () => {
    const channelId = props.match.params.uid;
    try {
      setIsLoading(true);
      const { data } = await getChannels(0, { searchItem: 'uid', search: channelId });
      const channel = data.rows[0];
      setChannel(channel);
      if (channel.addressId) {
        const { data: addressInformation } = await getAddressInformation(channel.uid);
        setAddress(addressInformation);
      }

      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
      console.log(error);
    }
  };

  const getPlansRewards = async () => {
    try {
      // const { data: channelPlans } = await getChannelSubscriptionPlans(0, { searchItem: 'channelId', search: channel.id });
      // const { data: channelRewards } = await getChannelRewards(0, { searchItem: 'channelUid', search: channelUid });
      // if (channelPlans && channelPlans?.rows.length) {
      //   const enabledChannelPlans = channelPlans.rows.filter(plan => plan.enabled);
      //   setChannelPlans(enabledChannelPlans);
      // }
      const { data: plans } = await getChannelPlansBySlug(channel.slug);
      if (plans?.groupedPlans && plans?.groupedPlans?.tier0 && plans?.groupedPlans?.tier0?.length) {
        const tier0 = plans.groupedPlans.tier0;
        setChannelPlans(tier0);
      }
    } catch (error) {
      dispatch(showAlert('error', error.message));
      console.log(error);
    }
  };

  const getChannelMembers = async () => {
    try {
      const data = await getChannelMembersByUid(channel.uid);
        setChannelMembers(data.rows);
    } catch (error) {
      dispatch(showAlert('error', error.message));
      console.log(error);
    }
  };

  const callAPIToReceiveRecipientData = async channelUid => {
    try {
      const { data } = await getRecipientData(channelUid);
      setRecipient(data);
    } catch (error) {
      console.log(error);
      dispatch(showAlert('error', 'Recipient Data Not Available'));
    }
  };

  const handleGiveSaas = useCallback(async () => {
    try {
      setIsLoadingGiveSaas(true);
      const saasIds = currentSaasPlanSelected.split(',').map(id => id.trim()).filter(Boolean);
      await giveSaasForFree(saasIds, channel.uid);
      dispatch(showAlert('success', 'Saas has been given! 🔥'));
      setIsLoadingGiveSaas(false);
    } catch (error) {
      setIsLoadingGiveSaas(false);
      dispatch(showAlert('error', 'This channel could not be given a free plan. 😔'));
    }
  }, [currentSaasPlanSelected]);

  const handleFileUpload = async (e, channelSegmentedListId) => {
    // CSV
    if (Object.keys(e).length !== 0 && importType === 'csv') {
      try {
        setIsLoadingFile(true);
        const file = new FormData();
        file.append('file', e.target.files[0]);
        await sendCsv(uid || channel.uid, file, channelSegmentedListId);
        setResetFile(true);
        setIsLoadingFile(false);
        dispatch(showAlert('success', 'imported!'));
      } catch (error) {
        dispatch(showAlert('error', 'something wrong happend'));
      } finally {
        setIsLoadingFile(false);
      }
      return;
    }
    // IMPORTS
    if (Object.keys(e).length !== 0) {
      try {
        setIsLoadingFile(true);
        const file = new FormData();
        const userId = channel.userId;
        file.append('file', e.target.files[0]);
        file.append('type', importType);
        file.append('userId', userId);
        await sendImportFile(channel.id, file);
        setResetFile(true);
        setIsLoadingFile(false);
        dispatch(showAlert('success', 'imported!'));
      } catch (error) {
        dispatch(showAlert('error', 'something wrong happend'));
      } finally {
        setIsLoadingFile(false);
      }
      return;
    } else {
      dispatch(showAlert('error', 'Select a file'));
      return;
    }
  };

  const handleChangeWithdrawToManual = async () => {
    try {
      setWithdrawChangeRequesting(true);
      await setRecipientToManual(channel.uid);
      dispatch(showAlert('success', 'Withdraw is now manual! 🥦🥬🍟'));
    } catch (error) {
      dispatch(showAlert('error', error.message));
    } finally {
      setWithdrawChangeRequesting(false);
    }
  };

  const handleUpdateAddress = async () => {
    try {
      await addAddressToChannel(channel.uid, address);
      dispatch(showAlert('success', ' New address set as default! 🏠'));
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  const changeHandle = e => {
    setSelectedFile(e.target.files[0]);
    setIsFilePicked(true);
  };

  const handleChangeCustomTemplateFile = e => {
    setSelectedFile(e.target.files[0]);
    setIsFilePicked(true);
  };

  const handleReset = () => {
    setSelectedFile('');
    setIsFilePicked(false);
    setFileText({ title: '', description: '', author: '' });
    setScheduledTo({ scheduledDate: moment().toDate() });
  };

  const handleResetCustomTemplate = () => {
    setSelectedFile('');
    setIsFilePicked(false);
    setCustomTemplateFile({ customTemplateFile: '', subject: '' });
  };

  const handleSubmissionCustomTemplate = async e => {
    try {
      const { typeTransactionalEmail, subject } = customTemplateFile;
      setIsLoadingTemplate(true);
      const file = new FormData();
      file.append('file', selectedFile);
      file.append('typeTransactionalEmail', typeTransactionalEmail);
      file.append('subject', subject);
      file.append('userId', channel.userId);
      await createCustomTemplate(channel.uid, file);
      dispatch(showAlert('success', 'imported!'));
    } catch (error) {
      dispatch(showAlert('error', 'something wrong happend'));
    } finally {
      handleReset();
      setIsLoadingTemplate(false);
    }
    return;
  };

  const getPlansTypes = async () => {
    try {
      const { data } = await getChannelPlans(channel.uid);
      const { Plan1, Plan2 } = data;
      console.log(data);
      setPlansValue({ Plan1: Plan1.value, Plan2: Plan2.value });
      setPlansInterval({ Plan1: Plan1.interval, Plan2: Plan2.interval });
      setPlansType({ Plan1: Plan1.planType, Plan2: Plan2.planType });
    } catch (error) {
      dispatch(showAlert('error', 'something wrong happend'));
    } finally {
      setIsLoadingTemplate(false);
    }
  };

  const listCustomSenders = async () => {
    try {
      setIsLoadingCustomSenders(true);

      const { data: channelCustomSenderData } = await getChannelCustomSender(channel.uid);

       setCustomSenders(channelCustomSenderData.rows);

      setIsLoadingCustomSenders(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  const handleAddNewPlanReward = async () => {
    try {
      await addRewardToPlan(channel.uid, rewardModalConfig.planId, rewardNameValue);
      dispatch(showAlert('success', 'Plan Reward Added!'));
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  const handleRemovePlanReward = async (planUid, rewardId) => {
    try {
      await removePlanReward(planUid, rewardId);
      dispatch(showAlert('success', 'Plan Reward removed!'));
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  const getTemplateStyles = async () => {
    try {
      const { data } = await getEmailTemplateStyles(channel.uid);
      setEmailTemplateStyles(data.rows);
    } catch (error) {
      console.log(error);
      dispatch(showAlert('error', 'something wrong happend'));
    }
  };

  const handleAddNewTemplateStyles = async () => {
    try {
      const { data } = await addNewEmailTemplateStyle(channel.uid);
      setEmailTemplateStyles([data, ...emailTemplateStyles]);
      dispatch(showAlert('success', 'New Template Style Added! Now you need to enable it!'));
    } catch (error) {
      console.log(error);
      dispatch(showAlert('error', 'something wrong happend'));
    }
  };

  const handleUpdatePlans = async () => {
    const plans = {
      plan1: { value: plansValue.Plan1, currency: 'brl', planType: plansType.Plan1, interval: plansInterval.Plan1 },
      plan2: { value: plansValue.Plan2, currency: 'brl', planType: plansType.Plan2, interval: plansInterval.Plan2 },
    };
    try {
      await updateChannelPlans(plans, channel.uid);

      dispatch(showAlert('success', 'Plan Changed!'));
    } catch (error) {
      dispatch(showAlert('error', 'something wrong happend'));
    } finally {
      setIsLoadingTemplate(false);
    }
  };

  const renderPlansInterval = (currency, plan) => {
    if (currency === 'month') {
      setPlansInterval({ ...plansInterval, [plan]: '1' });
      setPlansType({ ...plansType, [plan]: 'month' });
    } else if (currency === 'quarterly') {
      setPlansInterval({ ...plansInterval, [plan]: '3' });
      setPlansType({ ...plansType, [plan]: 'month' });
    } else if (currency === 'semester') {
      setPlansInterval({ ...plansInterval, [plan]: '6' });
      setPlansType({ ...plansType, [plan]: 'month' });
    } else if (currency === 'yearly') {
      setPlansInterval({ ...plansInterval, [plan]: '1' });
      setPlansType({ ...plansType, [plan]: 'year' });
    }
  };

  const renderSelectInterval = plan => {
    const planType = plansType[plan];
    const interval = plansInterval[plan];

    const isMonthly = interval === 1 && planType === 'month';
    const isEveryThreeMonths = interval === 3 && planType === 'month';
    const isEverySixMonths = interval === 6 && planType === 'month';
    const isYearly = interval === 1 && planType === 'year';

    if (isMonthly) return selectTypes[0];
    if (isEveryThreeMonths) return selectTypes[1];
    if (isEverySixMonths) return selectTypes[2];
    if (isYearly) return selectTypes[3];
  };

  const clearCache = async () => {
    try {
      await clearCacheCloudFront();
      dispatch(showAlert('success', 'Cache successfully cleared! 🔥'));
    } catch (error) {
      dispatch(showAlert('error', 'Error! We could not clear the cache. 😔'));
      console.log(error);
    }
  };

  const editable = [
    'name',
    'authorName',
    'description',
    'slug',
    'price',
    'currency',
    'utmMedium',
    'utmSource',
    'defaultIssuePrice',
    'imgUrl',
    'customFooterHTML',
    'bannerUrl',
  ];

  const select = [
    'isPublic',
    'isSellingLooseContent',
    'subscriptionEnabled',
    'hasPaymentIntegration',
    'isPixActive',
    'verified',
    'isEnabled',
    'showPaywallInLoop',
    'showDonateInLoop',
    'enabledLoop',
    'usingCustomDomain',
  ];

  const uneditable = ['id', 'userId', 'uid', 'createdAt', 'updatedAt'];

  const editableAddress = ['state', 'city', 'neighborhood', 'street'];

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="page-header">
        <h1>{channel.name}</h1>
        <div>
          {channel.uid === '6bcd72d4-224c-4e22-b89b-a0e8b61812da' ? (
            <Button variant="contained" onClick={clearCache} style={{ marginRight: '10px' }}>
              Clear Cache
            </Button>
          ) : null}
          <FormControlLabel
            control={
              <Switch
                className="enabled-switch"
                checked={channel.isEnabled}
                onChange={e => setChannel({ ...channel, [e.target.name]: e.target.checked })}
                name="isEnabled"
                color="primary"
              />
            }
            label="Enabled"
            labelPlacement="start"
          />
        </div>
      </div>
      <section className="metrics-section" data-testid="metrics-section">
        <h3>Channel Data</h3>
        <ChannelInfos channelUid={channel.uid} />
      </section>

      <AppBar position="static">
        <Tabs
          value={panelIndex}
          data-testid="container-edit"
          onChange={(e, value) => {
            setPanel(value);
          }}
          aria-label="simple tabs example"
        >
          <Tab label="Edit" data-testid="buttonEdit" />
          {/* <Tab label="Payment Manager" data-testid="button-payment" /> */}
          <Tab label="Import/Export" data-testid="btn-import-export" />
          <Tab label="SaaS" data-testid="btn-saas" />
          <Tab label="Custom Template" />
          <Tab label="Email Template Styles" />
          {/* <Tab label="Subscriptions Plans" /> */}
          <Tab label="Custom Senders" />
          <Tab label="Plans Rewards" />
          <Tab label="Plan Info" />
        </Tabs>
      </AppBar>

      <TabPanel value={panelIndex} index={0}>
        <section className="update-section" data-testid="container-edit-channel">
          <h3>Edit Channel</h3>
          <form onSubmit={handleUpdate} className="update-form">
            <div className="form-fields">
              <EditableInput data={channel} setData={setChannel} labels={editable} data-testid="input-edit" />
              <EditableSelect data={channel} setData={setChannel} labels={select} />
              <EditableSelect data={channel} setData={setChannel} labels={['deletedAt']} isDeletedAt />
              <EditableSelect data={channel} setData={setChannel} labels={['colorTheme']} isColorTheme />
              <UneditableInput data={channel} labels={uneditable} />
            </div>
            <Button data-testid="button-update-channel" type="submit" className="update-btn" variant="contained" startIcon={<Save />}>
              Update Channel
            </Button>
            <div className="address-section">
              <h3> Address Information</h3>
              <EditableInput data={address} setData={setAddress} labels={editableAddress} />
              <TextField
                InputLabelProps={{ shrink: true }}
                label="Number"
                value={address.number}
                onChange={e => setAddress({ ...address, number: e.target.value })}
              />
              <TextField
                InputLabelProps={{ shrink: true }}
                label="Postal Code"
                value={address.postalCode}
                onChange={e => setAddress({ ...address, postalCode: e.target.value })}
              />
              <TextField
                InputLabelProps={{ shrink: true }}
                label="Complement"
                value={address.complement}
                onChange={e => setAddress({ ...address, complement: e.target.value })}
              />
              <Button onClick={handleUpdateAddress} className="update-btn" variant="contained">
                Update Address
              </Button>
            </div>
          </form>
        </section>
      </TabPanel>

      {/* <TabPanel value={panelIndex} index={1}>
        {recipient && (
          <section className="update-section" data-testid="container-gateway">
            <h3>Gateway Data</h3>
            <Grid>
              <Grid container>
                {recipient && Object.keys(recipient).length > 0 && (
                  <>
                    <Grid>
                      <CardMetrics
                        data={{
                          totalBalance: recipient.total,
                          availableBalance: recipient.available,
                          status: recipient.statusInOrigin,
                        }}
                      />
                    </Grid>
                    <Divider />
                  </>
                )}
                <Grid item xs={12}>
                  <form onSubmit={handleUpdate} className="update-form">
                    <div className="form-fields">
                      <UneditableInput data={recipient} labels={Object.keys(recipient)} />
                    </div>
                  </form>
                </Grid>
                <Grid item xs={12}>
                  {!withdrawChangeRequesting && (
                    <Button
                      onClick={() => {
                        handleChangeWithdrawToManual();
                      }}
                      variant="contained"
                      className="search-clear-btn"
                      color="primary"
                    >
                      Set Withdraw to Manual
                    </Button>
                  )}
                  {withdrawChangeRequesting && (
                    <Button onClick={() => {}} variant="contained" className="search-clear-btn" color="primary" disabled={true}>
                      Changing...
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Divider className="divider-margin" />
            <Grid>
              <h3>Historic</h3>
              <Grid container justify={'space-between'} spacing={2}>
                <Grid item xs={5}>
                  <h4>Transactions</h4>
                  <Payments channelId={channel.id} />
                </Grid>
                <Grid item xs={5}>
                  <h5>Withdraws</h5>
                  <Payments onlyWithDraws={true} channelId={channel.id} />
                </Grid>
              </Grid>
            </Grid>
            <Divider className="divider-margin" />
            <Grid>
              <h3>Bank Accounts</h3>
              <Grid container justify={'space-between'} spacing={2}>
                <Grid item xs={5}>
                  <BankAccounts channelId={channel.id} />
                </Grid>
                <Grid item xs={5}>
                  <Recipients channelId={channel.id} />
                </Grid>
              </Grid>
            </Grid>
          </section>
        )}
      </TabPanel> */}

      <TabPanel value={panelIndex} index={1}>
        <section>
          <ImportData
            channelUid={props.match.params.uid}
            isLoadingFile={isLoadingFile}
            onSubmit={handleFileUpload}
            resetFile={resetFile}
            importType={importType}
            onChangeType={e => {
              setImportType(e);
            }}
          />
          {/* <ExportData
            channelUid={channel.uid}
            isLoadingFile={isLoadingFile}
            onSubmit={e => {
              handleFileUpload(e);
            }}
            resetFile={resetFile}
            importType={importType}
            onChangeType={e => {
              setImportType(e);
            }}
          /> */}
        </section>
      </TabPanel>

      <TabPanel value={panelIndex} index={2}>
        <section className="channel-saas">
          <div className="channel-saas__free">
            <h3>Give SaaS for Free</h3>
            {isLoadingGiveSaas ? (
              <Loading />
            ) : (
              <>
                <div className="channel-saas__free__select">
                  <div className="category-select" data-testid="select-saas">
                    <Input
                      value={currentSaasPlanSelected}
                      onChange={e => setCurrentSaasPlanSelected(e.target.value)}
                      placeholder="SaaS Plan ID(s), separated by commas"
                    />
                  </div>

                  <Button data-testid="btn-give-saas" className="channel-saas__button" onClick={handleGiveSaas}>
                    Give SaaS Plan for Free
                  </Button>
                </div>
              </>
            )}
          </div>
        </section>
      </TabPanel>

      <TabPanel value={panelIndex} index={3}>
        <section className="send-template">
          <h3>Import HTML Custom Template</h3>
          <div className="send-template__input">
            <TextField
              label="Subject"
              variant="outlined"
              value={customTemplateFile.subject}
              onChange={e => setCustomTemplateFile({ ...customTemplateFile, subject: e.target.value })}
            />
            <div className="channel-saas__free__select">
              <div className="category-select" data-testid="select-saas">
                <Select
                  data-testid="select-input"
                  onChange={e => setCustomTemplateFile({ ...customTemplateFile, typeTransactionalEmail: e.value })}
                  placeholder="Select a Type"
                  options={templateTypes}
                />
              </div>
            </div>

            <div className="send-template__file">
              <label className="bp3-file-input bp3-fill">
                <input type="file" name="file" accept=".html" onChange={e => handleChangeCustomTemplateFile(e)} />
                {isFilePicked ? (
                  <div className="send-template__file__name">
                    <p>File name: {selectedFile.name}</p>
                    <p>File type: {selectedFile.type}</p>
                  </div>
                ) : (
                  <span className="bp3-file-upload-input">Import HTML Custom Template </span>
                )}
              </label>

              <div className="send-template__submit">
                {isLoadingTemplate ? (
                  <Loading />
                ) : (
                  <Button
                    size="large"
                    data-testid="send-template"
                    className="send-template__button"
                    onClick={handleSubmissionCustomTemplate}
                  >
                    Import
                  </Button>
                )}

                <Button
                  size="large"
                  data-testid="send-template"
                  variant="outlined"
                  className="send-template__clear"
                  onClick={handleResetCustomTemplate}
                >
                  Clear
                </Button>
              </div>
            </div>
          </div>
        </section>
      </TabPanel>

      <TabPanel value={panelIndex} index={4}>
        <section>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <h3>Email Template Styles</h3>
            <Button onClick={handleAddNewTemplateStyles}>New template</Button>
          </div>
          {emailTemplateStyles.length ? (
            <DataTable
              head={dataTableEmailTemplateStylesHeaders}
              body={emailTemplateStyles}
              action={true}
              bodyColumn={dataTableEmailTemplateStylesHeaders}
              linkPath="email-template-styles"
            />
          ) : null}
        </section>
      </TabPanel>

      {/* <TabPanel value={panelIndex} index={7}>
        {Object.keys(plansType).length > 0 ? (
          <div className="subscriptions-plans">
            <div className="subscriptions-plans__group">
              <div className="subscriptions-plans__group__items category-select" data-testid="select-saas">
                <Select
                  data-testid="select-input"
                  onChange={e => renderPlansInterval(e.value, 'Plan1')}
                  placeholder="Select a Type"
                  options={selectTypes}
                  defaultValue={renderSelectInterval('Plan1')}
                />

                <InputBase
                  placeholder={formatCurrency(currency, plansValue.Plan1) || 'Enter with the plan value ...'}
                  inputProps={{ 'aria-label': 'search' }}
                  className="subscriptions-plans__group__items__input"
                  onChange={e => setPlansValue({ ...plansValue, Plan1: formatCurrencyToApiString(e.target.value) })}
                  data-testid="search-input"
                />
              </div>
              <div className="subscriptions-plans__group__items category-select" data-testid="select-saas">
                <Select
                  data-testid="select-input"
                  onChange={e => renderPlansInterval(e.value, 'Plan2')}
                  placeholder="Select a Type"
                  options={selectTypes}
                  defaultValue={renderSelectInterval('Plan2')}
                />
                <InputBase
                  placeholder={formatCurrency(currency, plansValue.Plan2) || 'Enter with the plan value ...'}
                  inputProps={{ 'aria-label': 'search' }}
                  className="subscriptions-plans__group__items__input"
                  onChange={e => setPlansValue({ ...plansValue, Plan2: formatCurrencyToApiString(e.target.value) })}
                  data-testid="search-input"
                />
              </div>
            </div>

            <Button
              type="submit"
              className="subscriptions-plans__group__btn"
              variant="contained"
              startIcon={<Save />}
              onClick={handleUpdatePlans}
            >
              Send
            </Button>
          </div>
        ) : null}
      </TabPanel> */}

      <TabPanel value={panelIndex} index={5}>
        <section>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <h3>Custom Senders</h3>
          </div>
        
        
          {customSenders.length ? (
            <DataTable
              body={customSenders}
              head={['id', 'domain', 'status', 'deletedAt']}
              bodyColumn={['id', 'domain', 'status', 'deletedAt']}
              action={false}
              linkPath="custom-senders"
            />
          ) : null}
        </section>
      </TabPanel>

      <TabPanel value={panelIndex} index={6}>
        <section>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <h3>Channel Members</h3>
          </div>
        
        
          {channelMembers.length ? (
            <DataTable
              body={channelMembers}
              head={['id', 'userUid', 'role', 'status', 'invitedBy', 'invitedAt']}
              bodyColumn={['id', 'userUid', 'role', 'status', 'invitedBy', 'invitedAt']}
              action={false}
              linkPath="channel-members"
            />
          ) : null}
        </section>
      </TabPanel>

      {/* <TabPanel value={panelIndex} index={6}>
        <section>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <h3>Plans Rewards</h3>
          </div>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '64px' }}>
            {channelPlans.map(plan => (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <span style={{ fontSize: '24px', fontWeight: 'bold' }}>{plan.name}</span>
                <span>Period of months: {plan.periodOfMonths}</span>
                <span>Value: {plan.value}</span>

                <span style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '24px' }}>Rewards</span>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  {plan.rewards
                    .filter(reward => reward.hasPlanReward === true)
                    .map(reward => (
                      <span style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                        {reward.order}. <strong>{reward.name}</strong>
                        <Button bgColor="red" onClick={() => handleRemovePlanReward(plan.uid, reward?.id)}>
                          <TrashCanIcon />
                        </Button>
                      </span>
                    ))}

                  <Button bgColor="green" appearence="solid" onClick={() => setRewardModalConfig({ isOpen: true, planId: plan.uid })}>
                    Add Reward
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </section>
      </TabPanel> */}

      <TabPanel value={panelIndex} index={7}>
        <section>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <h3>Plan info</h3>
          </div>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '64px' }}>
            <PlanComsumptionTable channelUid={channel.uid} />
          </div>
        </section>
      </TabPanel>

      {/* <Modal isOpen={customSenderModalConfig.isOpen} onClose={() => setCustomSenderModalConfig({ isOpen: false, isEditMode: false })}>
        <Text tag="h2" type="subtitle" size={20} weight="semibold">
          Add alias
        </Text>
        <Text color="gray">By adding an alias to this custom sender, it will be used before the '@'.</Text>
        <br />
        <br />
        <Text color="gray">
          Example:
          <Text color="gray" weight="semibold">
            newsletter
          </Text>
          <Text color="gray">@domain.com</Text>
        </Text>
        <InputField
          style={{ marginTop: '16px' }}
          value={customSenderAlias}
          onChange={e => setCustomSenderAlias(e.target.value)}
          placeholder="Alias"
        />
        <Button fullWidth appearence="solid" mt="16px" isLoading={isLoadingAddCustomSender} onClick={handleSelectCustomSender}>
          Add
        </Button>
      </Modal> */}

      <Modal isOpen={rewardModalConfig.isOpen} onClose={() => setRewardModalConfig({ isOpen: false, planId: null })}>
        <Text tag="h2" type="subtitle" size={20} weight="semibold">
          Add plan reward
        </Text>
        <Text color="gray">The rewards will be displayed inside the plan card.</Text>
        <br />
        <br />

        <InputField
          value={rewardNameValue}
          onChange={e => setRewardNameValue(e.target.value)}
          label="Reward name"
          placeholder="Eg.: Early access to new features"
        />
        <Button fullWidth appearence="solid" mt="16px" onClick={handleAddNewPlanReward}>
          Add
        </Button>
      </Modal>
    </>
  );
};

export default ChannelsInformation;
